module.exports = __webpack_public_path__ + "images/ForumPayLogo-6b78a4a9eea9d76b712df8303ccc8055.png";